import {
    ArrowPathIcon,
    CheckIcon,
    ClockIcon,
    GlobeAltIcon,
    LockClosedIcon,
    MagnifyingGlassIcon,
} from '@heroicons/react/24/outline'
import React from 'react'

export const OfferBenefits: React.FC = () => {
    return (
        <>
            <h1 className="mt-10 font-bold text-white text-2xl">
                Получаемый эффект
            </h1>
            <ul className="mt-4 grid md:grid-cols-3 gap-8 items-center text-white text-lg">
                <li className="flex items-center gap-4 font-bold">
                    <div className="p-6 bg-[#1051F5] rounded-full">
                        <ArrowPathIcon width={24} height={24} />
                    </div>{' '}
                    Еженедельные обновления
                </li>
                <li className="flex items-center gap-4 font-bold">
                    <div className="p-6 bg-[#1051F5] rounded-full">
                        <LockClosedIcon width={24} height={24} />
                    </div>{' '}
                    Безопасность
                </li>
                <li className="flex items-center gap-4 font-bold">
                    <div className="p-6 bg-[#1051F5] rounded-full">
                        <CheckIcon width={24} height={24} />
                    </div>{' '}
                    Исключение ошибок
                </li>
                <li className="flex items-center gap-4 font-bold">
                    <div className="p-6 bg-[#1051F5] rounded-full">
                        <MagnifyingGlassIcon width={24} height={24} />
                    </div>{' '}
                    Удобный поиск
                </li>
                <li className="flex items-center gap-4 font-bold">
                    <div className="p-6 bg-[#1051F5] rounded-full">
                        <ClockIcon width={24} height={24} />
                    </div>{' '}
                    Экономия времени на поиск до 70%
                </li>
                <li className="flex items-center gap-4 font-bold">
                    <div className="p-6 bg-[#1051F5] rounded-full">
                        <GlobeAltIcon width={24} height={24} />
                    </div>{' '}
                    Встроенная нейросеть
                </li>
            </ul>
        </>
    )
}
